import React from 'react'

const FullPageTemplate = ({ children, bgColor }) => (
  <div style={{ background: bgColor, minHeight: '100%', height: 'auto' }} className="fullPageTemplate">
    {children}
  </div>
)

export default FullPageTemplate
